const levels = [
  { n: "01", label: "Beginner", desc: "Build the base — movement, consistency, foundational strength." },
  { n: "02", label: "Intermediate", desc: "Add structure — progressive overload and conditioning blocks." },
  { n: "03", label: "Advanced", desc: "Push capacity — sport-specific power, speed, and durability." },
  { n: "04", label: "Elite", desc: "Compete at high level — periodized, performance-driven phases." },
  { n: "05", label: "Professional", desc: "Train like a pro — performance KPI tracking and peaking cycles." },
  { n: "06", label: "Elite Professional", desc: "Top-tier athlete pathway with advanced testing and analytics." },
];

export default function LevelsSection() {
  return (
    <section
      id="levels"
      className="relative nfp-section bg-[#0a0a0a]"
      data-testid="section-levels"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#00E5FF] mb-4">
              Levels
            </p>
            <h2 className="nfp-heading text-white text-4xl md:text-6xl leading-[1] tracking-tight">
              From day one <br />
              to the <span className="text-[#00E5FF]">podium.</span>
            </h2>
          </div>
          <p className="md:max-w-md text-white/60 leading-relaxed">
            Whether you're just starting or training for high-level performance,
            NFP matches your current ability — and scales with you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border border-white/10 rounded-2xl overflow-hidden">
          {levels.map((l, i) => (
            <div
              key={l.label}
              data-testid={`level-card-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`relative p-7 md:p-9 bg-[#0a0a0a] hover:bg-[#101010] transition-colors group ${
                i < 3 ? "border-b border-white/10" : ""
              } ${i % 3 !== 2 ? "lg:border-r" : ""} ${
                i % 2 === 0 ? "sm:border-r sm:border-white/10" : ""
              } lg:border-white/10`}
            >
              <div className="flex items-baseline gap-4">
                <span className="nfp-mono text-xs text-[#00E5FF]">{l.n}</span>
                <span className="h-px flex-1 bg-white/10 group-hover:bg-[#1FA2FF]/40 transition-colors" />
              </div>
              <h3 className="nfp-heading text-white text-3xl mt-4 tracking-tight">
                {l.label}
              </h3>
              <p className="mt-2 text-sm text-white/55 leading-relaxed max-w-xs">
                {l.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
